import { PRIMIS_PLAYER_DIMENSION } from '../utils/ad-ops/assertive-yield/dimensions'
import { logAdImpressionToAY } from '../utils/ad-ops/assertive-yield/events'
import { onPrimisAdStart } from '../utils/ad-ops/primis'

// Primis serves outside GAM and Prebid, so AY only sees its revenue from here.
export default defineNuxtPlugin({
  name: 'primis-ad-revenue',
  setup() {
    onPrimisAdStart(
      ({ playerApiId, impValue, servingFee, playerWidth, playerHeight }) =>
        logAdImpressionToAY({
          source: 'video',
          slotId: 'primis_video',
          adUnitPath: 'primis_video',
          mediaType: 'primis_video',
          highestPreBid: impValue - servingFee,
          highestPreBid_partner: 'primis',
          preBidWon: true,
          creative_width: playerWidth,
          creative_height: playerHeight,
          [PRIMIS_PLAYER_DIMENSION]: playerApiId,
        })
    )
  },
})
